@use "~theme/typography";
@use "~theme/breakpoints";

.bannerCard {
    opacity: 1;
    gap: 24px;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 10px;
    background: var(--White-Off, var(--gray-05));
    border: 1px solid var(--blue-01);
    width: 100%;
    overflow: auto;
    @include breakpoints.desktop {
        padding: 6px 12px;
    }
}

.bannercontianer {    
    margin: 0px;
    @include breakpoints.desktop {
        padding: 0px 5%;
    }
}

.clockDiv {
    padding: 5px 0px;
    float: left;
}

.clockIcon {
    float: left;
    width: 20px;
    height: 20px;
}

.bannerText {
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: 0%;
    color: var(--Blue-Dark, var(--blue-01));
    float: left;
    padding: 5px;
    width:93%;
    span {        
        font-family: proxima-nova, sans-serif;
        font-weight: 700;
        font-style: Bold;
        font-size: 18px;
        line-height: 120%;
        letter-spacing: 0%;
        padding: 0px 0px 0px 3px;
    }
    @include breakpoints.desktop {
        padding: 5px 4px;
        width: auto;
    }
}

.bookTimediv {
    float:left;
    width:100%;
    @include breakpoints.desktop {
        margin: 0px 20px;
        width: auto;
    }
}

.bookTime {
    min-height: 33px;
    height: 33px;
    padding: 0px;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 0%;
    text-align: center;
    text-transform: uppercase;
    span {
        min-height: 33px;
        height: 33px;
    }
    width: 100%;
    @include breakpoints.desktop {
        width: auto;
    }
}